export default __webpack_public_path__ + "static/media/WindowsTaskScheduler-Action-StartaProgram05.7368d92e.png";